import { ICandidateDashboardStats } from '../../../models';

export class CandidateDashboardStatsGetters {
  static hasNewMessages(stats?: ICandidateDashboardStats): boolean {
    if (!stats || !stats.newMessages) return false;
    return stats!.newMessages > 0;
  }
}
